import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import * as API from '../api/index.js';
import { canCreateEventByDate } from './helper.js';
import { toggleModal } from '../reducers/generalReducer.js';
import { fetchTeamEvents } from './calendarThunks.js';
import { selectPerPage } from '../selectors/general.js';

export const fetchWorkingTimes = createAsyncThunk(
    'workingTime/fetch',
    async ({ page }, { getState, rejectWithValue }) => {
        try {
            const perPage = selectPerPage(getState());
            const { maxPageNumber, overtimes } = await API.workingTime.getAll(page, perPage);
            const { list } = getState().workingTime;

            return {
                maxPageNumber,
                list: page ? [...list, ...overtimes] : overtimes,
            };
        } catch (err) {
            notification.error({ message: 'Error', description: err.message || 'Server error' });
            return rejectWithValue(err.message);
        }
    },
);

export const createWorkingTime = createAsyncThunk(
    'workingTime/create',
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            await canCreateEventByDate(data.date);
            const payload = await API.workingTime.create(data);
            notification.info({ message: 'Success', description: 'Overtime was created' });
            dispatch(toggleModal({ modal: 'workingTime', isOpen: false }));
            await dispatch(fetchTeamEvents());
            return payload;
        } catch (err) {
            notification.error({ message: 'Error', description: err.message });
            return rejectWithValue(err.message);
        }
    },
);

export const updateWorkingTime = createAsyncThunk(
    'workingTime/update',
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            await canCreateEventByDate(data.date, id);
            const payload = await API.workingTime.update(data, id);
            notification.info({ message: 'Success', description: 'Overtime was updated' });
            dispatch(toggleModal({ modal: 'workingTimeEdit', isOpen: false }));
            await dispatch(fetchTeamEvents());
            return payload;
        } catch (err) {
            notification.error({ message: 'Error', description: err.message });
            return rejectWithValue(err.message);
        }
    },
);

export const deleteWorkingTime = createAsyncThunk(
    'workingTime/delete',
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            await API.workingTime.delete(id);
            notification.info({ message: 'Success', description: 'Overtime was deleted' });
            await dispatch(fetchTeamEvents());
            return { id };
        } catch (err) {
            notification.error({ message: 'Error', description: err.message });
            return rejectWithValue(err.message);
        }
    },
);
